import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { ListItem, ListItemText, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'

export const ResidualValueForm = (props: any) => {
  let history = useHistory()
  let location = useLocation()

  const editData: any = location?.state
  const { formMode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('user'))
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [record, setRecord] = useState(false)
  const [, setIsFormDirty] = useState(true)

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }
  const { menu } = useMenuOption()

  /* -------------------------------------------- */
  /*                   USE FORM                   */
  /* -------------------------------------------- */
  const { register, setValue, control } = useForm<any>({
    defaultValues: {},
    mode: 'onSubmit',
  })

  /* -------------------------------------------- */
  /*                    QUERY                    */
  /* -------------------------------------------- */
  let dummyData = [
    {
      Name: 'Machinery',
      AssetNo: 'A-000013',
      OriginalAmount: 200000,
      ModelNo: 'N/A',
      ResidualValue: 1.2,
      Description: 'Change description here',
      ResidualPercent: 0,
      StartDate: '2021-05-27T12:44:01.162Z',
    },
    {
      Name: 'Conference Room',
      AssetNo: 'A-000014',
      OriginalAmount: 250000,
      ModelNo: 'N/A',
      ResidualValue: 1.2,
      Description: 'Change description here',
      ResidualPercent: 0,
      StartDate: '2021-05-27T12:44:01.162Z',
    },
    {
      Name: 'Transportation',
      AssetNo: 'A-000015',
      OriginalAmount: 500000,
      ModelNo: 'N/A',
      ResidualValue: 1,
      Description: 'Change description here',
      ResidualPercent: 0,
      StartDate: '2021-05-27T12:44:01.162Z',
    },
  ]

  const draftFooterOption = {
    name: 'save as Draft',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  const rejectFooterOption = {
    name: 'Reject',
    onClick: () => {},
    color: 'red',
    props: { type: 'submit' },
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  const approveFooterOption = {
    name: 'Approve',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else if (editData?.mode === 'approve-reject') {
    footerOptions = [rejectFooterOption, approveFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  return (
    <>
      <MainHeader
        mainBtn="close"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/residual-value`
          )
        }}
        smTitle={'Fixed Assets'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Residual Value', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents>
          <Controller
            render={({ value, onChange }) => {
              const defVal = dummyData?.filter(
                coa => coa?.AssetNo === editData?.AssetNo
              )[0]
              return (
                <Autocomplete
                  options={
                    dummyData?.sort((a, b) => {
                      return a?.AssetNo?.localeCompare(b?.AssetNo)
                    }) || []
                  }
                  getOptionLabel={option => `${option?.AssetNo}`}
                  fullWidth
                  onChange={(event, value: any) => {
                    if (value) {
                      setValue('Name', value?.Name)
                      setValue('StartDate', value?.StartDate)
                      setValue('ModelNo', value?.ModelNo)
                      setValue('Description', value?.Description)
                      setValue('OriginalAmount', value?.OriginalAmount)
                      setValue('ResidualValue', value?.ResidualValue)
                      setValue('ResidualPercent', value?.ResidualPercent)
                    }
                  }}
                  defaultValue={defVal}
                  disabled={mode === 'approve-reject'}
                  renderOption={(props, option) => {
                    return (
                      <div>
                        <div>
                          <span className="xsTitle">{props?.AssetNo}</span>
                        </div>
                      </div>
                    )
                  }}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          label="Assets No."
                          style={{ width: '100%' }}
                          required
                          margin="normal"
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Asset No."
            name="AssetNo"
            autoComplete="off"
            control={control}
            multiline={true}
            margin="normal"
            ref={register}
            required
            fullWidth
            defaultValue={editData?.AssetNo}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="AssetName"
            label="Assets Name"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.AssetName ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="StartDate"
              label="Start Date"
              control={control}
              format="dd/MM/yyyy"
              readOnly
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                style: { display: 'none' },
              }}
              className="left"
              value={new Date()}
              defaultValue={menu?.obj?.StartDate ?? null}
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="ModelNo"
            label="Model No"
            autoComplete="off"
            control={control}
            className="right"
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.ModelNo ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            name="OriginalAmount"
            label="Original Amount"
            autoComplete="off"
            control={control}
            className="left"
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.OriginalAmount ?? 0}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            decimalScale={2}
            fixedDecimalScale
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualValue"
            label="Residual Value"
            className="right"
            defaultValue={menu?.obj?.ResidualValue ?? 0}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            decimalScale={2}
            fixedDecimalScale
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualPercent"
            label="Residual (%)"
            className="left"
            defaultValue={menu?.obj?.ResidualPercent ?? 0}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            decimalScale={4}
            fixedDecimalScale
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Residual (%) Adjustment' },
          }}
        >
          <>
            <Controller
              as={KeyboardDatePicker}
              name="ChangeDate"
              label="Date"
              control={control}
              format="dd/MM/yyyy"
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                style: { display: 'none' },
              }}
              value={new Date()}
              defaultValue={editData ? editData?.ChangeDate : new Date()}
              required
            />

            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangedResidualPercent"
              label="Residual (%)"
              className="right"
              defaultValue={menu?.obj?.ChangedProvisionAmount ?? 0}
              decimalScale={2}
              fixedDecimalScale
              required
            />

            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangedResidualValue"
              label="Residual Value"
              className="right"
              defaultValue={menu?.obj?.ChangedResidualValue ?? 0}
              decimalScale={2}
              fixedDecimalScale
              required
            />

            <VoiceTextField
              mounted={true}
              label="Document Description"
              name="Description"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />

            <VoiceTextField
              mounted={true}
              label="Reason"
              name="Reason"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />
          </>
        </CardContents>
      </ContentWrapper>

      {footerOptions?.length > 0 && (
        <AccountFooter options={[...footerOptions]} />
      )}

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {`Document Numbering is empty`}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{`Please setup Document Numbering to Submit.`}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/residual-value`
          )
        }}
      />
    </>
  )
}
